import React, { useContext } from 'react'
import { CoreContext } from '../../../core/context/CoreContext'
import NavigationDrawer from '../../../core/components/navigation/NavigationDrawer'
import Topbar from '../../../core/components/navigation/Topbar'
import GetNavItems from '../config/navigation'

function Navigation(props) {
  const core = useContext(CoreContext)

  return (
    <>
      <Topbar {...props}></Topbar>
      <NavigationDrawer
        open={props.isExpanded}
        flip={() => props.expandDrawer(!props.isExpanded)}
        history={core.history}
        upperItems={GetNavItems().upperNavigation}
        lowerItems={GetNavItems().lowerNavigation}
      />
    </>
  )
}

export default Navigation
